import axios from "axios";
import { toast } from "react-toastify";

const baseUrl = process.env.REACT_APP_API_URL;

axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem(
  "jwtToken"
)}`;

export default {
  /**
   *  Sends a basic GET request to the given endpoint and returns the data or error (if any)
   * @param {string} endpoint
   */
  get: async (endpoint, criteria = null) => {
    let res = null;
    let err = null;
    await axios
      .get(baseUrl + endpoint, { params: criteria })
      .then(response => {
        res = response;
      })
      .catch(error => {
        err = error;
      });
    return [res, err];
  },

  /**
   *  Sends a POST request to the given endpoint with the given data, returns true if it's successful
   * @param {*} endpoint
   * @param {*} data
   * @param {}
   */
  post: async (endpoint, data, uploadMessage = null, successMessage = null) => {
    let toastId;
    let success = true;
    const { CancelToken } = axios;
    const source = CancelToken.source();
    await axios
      .post(baseUrl + endpoint, data, {
        cancelToken: source.token,
        onUploadProgress: progressEvent => {
          const progress = progressEvent.loaded / progressEvent.total;
          if (progress === 1) {
            toast.done(toastId);
          } else if (!toastId) {
            toastId = toast.info(uploadMessage || "Upload in progress", {
              progress
            });
          } else if (!toast.isActive(toastId)) {
            source.cancel("User canceled operation");
          } else {
            toast.update(toastId, { progress });
          }
        }
      })
      .then(() => {
        toast.success(successMessage || "Upload complete");
      })
      .catch(err => {
        toast.error(`Error: ${err.message}`, {
          bodyClassName: "text-danger"
        });
        success = false;
      });
    return success;
  },

  /**
   *  Sends a PUT request to the given endpoint with the given data, returns true if it's successful
   * @param {*} endpoint
   * @param {*} data
   */
  put: async (endpoint, data, uploadMessage = null, successMessage = null) => {
    let toastId;
    let success = true;
    const { CancelToken } = axios;
    const source = CancelToken.source();
    axios
      .put(baseUrl + endpoint, data, {
        cancelToken: source.token,
        onUploadProgress: progressEvent => {
          const progress = progressEvent.loaded / progressEvent.total;
          if (progress === 1) {
            toast.done(toastId);
          } else if (!toastId) {
            toastId = toast.info(uploadMessage || "Upload in progress", {
              progress
            });
          } else if (!toast.isActive(toastId)) {
            source.cancel("User canceled operation");
          } else {
            toast.update(toastId, { progress });
          }
        }
      })
      .then(() => {
        toast.success(successMessage || "Upload complete");
      })
      .catch(err => {
        toast.error(`Error: ${err.message}`, {
          bodyClassName: "text-danger"
        });
        success = false;
      });

    return success;
  },

  /**
   *  Sends a DELETE request to the given endpoint, returns true if it's successful
   * @param {*} endpoint
   */
  del: async (endpoint, successMessage = null) => {
    let success = true;
    await axios
      .delete(baseUrl + endpoint)
      .then(() => {
        toast.success(successMessage || "Delete operation successful");
      })
      .catch(err => {
        toast.error(`Error: ${err.message}`, {
          bodyClassName: "text-danger"
        });
        success = false;
      });
    return success;
  }
};



// WEBPACK FOOTER //
// ./src/services/api/apiService.js